import { render, staticRenderFns } from "./PurchaseOrderOtherPurchases.vue?vue&type=template&id=06cf9323&scoped=true"
import script from "./PurchaseOrderOtherPurchases.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderOtherPurchases.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderOtherPurchases.vue?vue&type=style&index=0&id=06cf9323&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf9323",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06cf9323')) {
      api.createRecord('06cf9323', component.options)
    } else {
      api.reload('06cf9323', component.options)
    }
    module.hot.accept("./PurchaseOrderOtherPurchases.vue?vue&type=template&id=06cf9323&scoped=true", function () {
      api.rerender('06cf9323', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderOtherPurchases.vue"
export default component.exports